module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-1-9a2a35552c387914785f516c14bf09c0.jpg";